const _excluded = ["children", "className", "image"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import cn from 'classnames';
import styles from "./SuccessPage.module.scss";
import Success from "../assets/success.svg";
import Logo from "../assets/logo.svg";
import { Typography } from 'seagull';
import { useResponsive } from "../contexts";
export function SuccessPage(_ref) {
  let {
      children,
      className,
      image
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const {
    isMobile
  } = useResponsive();
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cn(styles.cover, className)
  }, rest), image !== null && image !== void 0 ? image : /*#__PURE__*/React.createElement(Success, {
    width: isMobile ? 170 : 312
  }), children, /*#__PURE__*/React.createElement(Typography, {
    skin: "secondary",
    variant: "paragraph2",
    className: styles.poweredByAnchor
  }, "Powered by", /*#__PURE__*/React.createElement(Logo, null)));
}